export const fundrasingExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{
		label: 'User Name',
		render: f => (f?.userId ? `${f.userId.firstName || ''} ${f.userId.lastName || ''}`.trim() : ''),
	},
	{
		label: 'User Mobile',
		render: f => f?.userId?.mobile || '',
	},
	{
		label: 'Contribution Type',
		render: f => f?.fundraisingType || '',
	},
	{
		label: 'Payment Type',
		render: f => (f?.isOnline ? 'Online' : 'Offline'),
	},
	{
		label: 'Amount',
		render: f => f?.amount ?? '',
	},
	{
		label: 'Payment Mode',
		render: f => f?.offlinePaymentMode || '',
	},
	{
		label: 'Payment Date',
		render: f => (f?.updatedAt ? new Date(f.updatedAt).toLocaleDateString('en-IN') : ''),
	},
]
